import ScrollTrigger from '@terwanerik/scrolltrigger'
import Swiper from 'swiper/bundle'
import { LuminousGallery } from 'luminous-lightbox'

// +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// ++  Main app
// ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
window.gi = window.gi || {}

$(function () {
  $('a[href^="#"]').click(function () {
    var adjust = 0
    var speed = 600
    var href = $(this).attr('href')
    var target = $(href == '#' || href == '' ? 'html' : href)
    var position = target.offset().top + adjust
    $('.js-navMobile').removeClass('is-open')
    // スムーススクロール linear（等速） or swing（変速）
    $('body,html').animate({ scrollTop: position }, speed, 'swing')
    return false
  })

  // // nav toggle
  $('.js-navOpen').on('click', function () {
    $('.js-navMobile').toggleClass('is-open')
  })

  $('.js-navMobile-close').on('click', function () {
    $('.js-navMobile').removeClass('is-open')
  })

  $('.p-works-tvList__toggle').on('click', function () {
    $(this).parent().toggleClass('is-close')
    // $(this).parent().find('.p-works-tvList__body').slideToggle()
  })

  // $('.js-navMobile').on('click', 'a', function () {
  //   $('.js-navMobile').removeClass('is-open')
  // })
})
